import { render } from "./GroupServicesTableHeader.vue?vue&type=template&id=3db656c6"
import script from "./GroupServicesTableHeader.vue?vue&type=script&lang=js"
export * from "./GroupServicesTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__